export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7885.9c5acee0.jpg";